import { render, staticRenderFns } from "./UpdateLinks.vue?vue&type=template&id=6f161d5e&"
import script from "./UpdateLinks.vue?vue&type=script&lang=ts&"
export * from "./UpdateLinks.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports